import { colors } from "@styles/colors";
import type { PointsKind } from "@utils/points";

/**
 * 兩種點數的識別色：存氣＝琥珀（氣、火），帳戶＝藍（錢）。
 *
 * 飽和的那一階只給圖示與金額；底色一律是同色的極淡階（6%／15%），
 * 全站的列是白底 + 圖示色塊 + 細分隔線（見 FnRow / ToggleRow），
 * 點數不自己長成填色面板 —— 但「已選取」需要一點顏色才看得出狀態，故留一階 wash。
 */
export interface PointsTint {
  /** 圖示本體與強調數字 */
  icon: string;
  /** 圖示底色（主色 15%，與 FnRow / ToggleRow 同一個做法） */
  tile: string;
  /** 啟用中的列／換算金額 chip 的底（主色 6%，淡到只當狀態暗示，不會變成色塊） */
  wash: string;
}

export const POINTS_TINT: Record<PointsKind, PointsTint> = {
  stored_gas: { icon: colors.amber, tile: `${colors.amber}15`, wash: `${colors.amber}0F` },
  account: { icon: colors.primary, tile: `${colors.primary}15`, wash: `${colors.primary}0F` },
};

/** V2 白卡的柔和藍陰影（SkinCard / ListContainer 同一顆）。 */
export const SOFT_SHADOW = "0 2px 10px -4px rgba(21, 101, 192, 0.10)";
